// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5326) return "static/chunks/5326-252180f63dcb4aac.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1160":"28d2f374adc59d8e","2233":"26679e9dcabeed58","3681":"10906efc282673e3","4462":"df1ef853f90fab8a","8356":"7752b59756155377","9917":"58958228d96de108"}[chunkId] + ".js";
};